import i18next from 'i18next';

import apiOffers from 'api/offers';
import downloadNamedFile from 'services/files/downloadNamedFile';
import { finishLoading, startLoading } from 'store/loading/actions';
import { addMessage } from 'store/messages/actions';
import store from 'store/store';
import { ADDITIONAL_OFFER } from '../../../services/enums/offers/offerTypes';
import openPdfInNewTab from '../../../services/files/openPdfInNewTab';

// Customer companies of the offer in the order they were added
const getCustomerCompanies = (customerContacts: any[]) =>
  customerContacts
    .map((customerContact) => customerContact.contact)
    .filter(
      (contact, index, contacts) =>
        contact != null &&
        contacts.findIndex((other) => other?.id === contact.id) === index
    );

/**
 * Opens the offer PDF. An offer sent to several customer companies (e.g. a preliminary
 * offer) is printed as a separate file for each company, named
 * "<Offer type> <target name> (<company>).pdf".
 */
const openOfferPdf = async (id: number, offerType: string): Promise<void> => {
  store.dispatch(startLoading('offer-pdf'));

  try {
    if (offerType === ADDITIONAL_OFFER) {
      const response = await apiOffers.additionalOffers.pdfs.get(id);
      openPdfInNewTab(response.data, response.headers);
      return;
    }

    const offer = await apiOffers.getOffer(id);
    const companies = getCustomerCompanies(offer.customerContacts ?? []);

    if (companies.length <= 1) {
      const response = await apiOffers.pdfs.get(id);
      openPdfInNewTab(response.data, response.headers);
      return;
    }

    const typeName = i18next.t(`offers:types.${offer.type}`);

    // Sequentially, so the browser handles the downloads one at a time
    // eslint-disable-next-line no-restricted-syntax
    for (const company of companies) {
      // eslint-disable-next-line no-await-in-loop
      const response = await apiOffers.pdfs.get(id, company.id);
      downloadNamedFile(
        response.data,
        'application/pdf',
        `${typeName} ${offer.targetName} (${company.companyName}).pdf`
      );
    }
  } catch (error) {
    store.dispatch(addMessage(i18next.t('offers:pdfPreview.Load failed')));
  } finally {
    store.dispatch(finishLoading('offer-pdf'));
  }
};

export default openOfferPdf;
